module.exports = __webpack_public_path__ + "static/36-12n-379o-02-0e27a16e0a467bab742f0eb820996d61.jpg";